<script>
export default {
    name: "IconDrop"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" fill="none" viewBox="0 0 8 4"><path fill="#6A7787" fill-rule="evenodd" d="M6.346.22c1.212 0 1.527.67.741 1.515l-.088.09L5.642 3.17a2.304 2.304 0 0 1-3.13.106l-.115-.106L1.04 1.826C.168.962.417.269 1.566.222L1.693.22h4.653Z" clip-rule="evenodd"/></svg>
</template>

<style scoped lang="scss">

</style>